export enum MENU_LIST_ITEM_VARIANTS {
  ITEM = "item",
  TITLE = "title"
}

export enum SidebarLayoutType {
  PROJECT = "project",
  ORGANISATION = "organisation"
}

/** Row icons are 16px in the design; the rail's tiles draw them a touch larger. */
export const MENU_ITEM_ICON_SIZE = 16;
/**
 * Heavier than lucide's 2. At 16px a 2-weight stroke renders at 1.33 device
 * pixels and the rail read as a column of grey smudges rather than of icons.
 */
export const MENU_ITEM_ICON_STROKE = 2.4;
// Defined in `@themes/tokens/sidebar` because layers below this one need them
// too — see the note there. Re-exported so the sidebar's own imports are
// unchanged and there is exactly one definition.
export { COLLAPSED_WIDTH, DRAWER_WIDTH } from "@themes/tokens/sidebar";
